import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { ClientLocation } from "@interfaces/clientLocation.interface";
import { DeliveryNote } from "@interfaces/deliveryNote.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { ClientService } from "@services/client.service";
import { ClientLocationService } from "@services/clientLocation.service";
import { DeliveryNoteService } from "@services/deliveryNote.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "deliveryNotes-deleted",
	styleUrls: ["deliveryNotes-deleted.css"],
	templateUrl: "deliveryNotes-deleted.html"
})
export class DeliveryNotesDeletedAdminComponent {
	canExportGrid = false;
	clientLocations: ClientLocation[] = [];
	clients: Client[] = [];
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [{ method: "viewDeliveryNotes", text: "Return to Delivery Notes" }];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Delivery Note"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: DeliveryNote[] = [];
	title: string;
	userProfiles: UserProfile[] = [];
	
	constructor(private router: Router, private toastService: ToastService, private itemService: DeliveryNoteService, private clientService: ClientService, private clientLocationService: ClientLocationService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService) {
		this.title = "Deleted Delivery Notes";
		this.viewDeliveryNotes = this.viewDeliveryNotes.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.getItems();
		this.getClients();
		this.getClientLocations();
		this.getUserProfiles();
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Deleted Delivery Notes")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getClientLocations() {
		this.clientLocationService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clientLocations = res.response.items;
				},
				(err) => console.log(err)
			);
	}
	
	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clients = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getDeleted()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getUserProfiles(){
		this.userProfileService.getAll()
			.subscribe(
				(res: any) => {
					this.userProfiles = res.response.items;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Deleted Delivery Notes";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewDeliveryNotes() {
		this.router.navigate([`${this.itemUrl}`]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}
}